import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8.848 14.667l-3.348 2.833","key":"svg-0"}],["path",{"d":"M12 3v5m4 4h5","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-2"}],["path",{"d":"M14.219 15.328l2.781 4.172","key":"svg-3"}],["path",{"d":"M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-4"}]]

const IconChartDonut4 = createReactComponent('outline', 'chart-donut-4', 'ChartDonut4', __iconNode);

export default IconChartDonut4;